import type { ReactNode } from 'react'

export interface BenefitItemProps {
  icon: React.ComponentType<{ className?: string }>
  title: string
  description: string
}

export const BenefitItem: React.FC<BenefitItemProps> = ({
  icon: Icon,
  title,
  description,
}): ReactNode => (
  <div className="flex gap-3">
    <div className="flex size-10 flex-shrink-0 items-center justify-center rounded-lg bg-primary/10">
      <Icon className="size-5 text-primary" />
    </div>
    <div className="flex flex-col gap-0.5">
      <span className="text-sm font-medium">{title}</span>
      <span className="text-xs text-muted-foreground">{description}</span>
    </div>
  </div>
)
